module.exports = __webpack_public_path__ + "static/vetorizador-poster-e100a43e2af66bf08a52e5052993d5b4.jpg";